import React from "react"
import SnakeBlock from "../SnakeBlock"
import ConnectorBlock from "../ConnectorBlock"
import SearchBar from "../SearchBar"
import { reverseArr } from "../../utils/reverseArr"

const MobileGameContainer = ({ 
    head,
    isMobile,
    check,
    tail,
    gameStatus,
    blocksFwd,
    blocksBck,
    direction,
    setDirection,
    guessStatus,
    setShowGoBack,
    screenshotReference,
    usedIds,
    triggerHint
}) => {

    const createBlocksMobile = (b, fwdOrBck) => {
        if (b.length === 0) {
            return null
        }
        else {
            return(
                b.map((block, idx) => (
                    <div key={idx} >
                        <SnakeBlock showGoBack={() => setShowGoBack(idx, fwdOrBck)} key={block.id} info={block} guessStatus={guessStatus} />
                        <ConnectorBlock isMobile={true} height={50} color={'black'} key={idx} />
                    </div>
                ))
            )
        }
    }
    const flip = () => {
        let newDirection = "bck"
        if (direction === "bck") {
            newDirection = "fwd"
        }
        setDirection(newDirection)
    }

    const currentSearchType = ()=>{
        let final
        if (direction === 'fwd' && blocksFwd.length === 0){
            final = head?.type
        }
        else if (direction === 'bck' && blocksBck.length === 0){
            final = tail?.type
        }
        else if(direction === 'fwd'){
            final = blocksFwd[blocksFwd.length-1]?.type
        }
        else{
            final = blocksBck[blocksBck.length-1]?.type
        }
        if (final === 'MEDIA'){
            return 'ACTOR'
        }
        else{
            return 'MEDIA'
        }
    }

    return(
        <div style={{ display:'flex'}}>
            <div 
                ref={screenshotReference} 
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', overflowY: 'scroll', backgroundColor:'black'}}>
                    <SnakeBlock showGoBack={() => setShowGoBack(-1)} info={direction === 'fwd' ? head : tail} />
                    <ConnectorBlock isMobile={isMobile} color={'black'}/>
                    {createBlocksMobile(direction === 'fwd' ? blocksFwd : blocksBck, direction === 'fwd'? 'fwd' : 'bck')}
                    {(gameStatus === "in progress" ) &&
                        <div style={{ width: '100%', marginBottom: 10, marginTop:10 }}>
                            <SearchBar 
                                select={(suggestion) => check(suggestion)} 
                                type={currentSearchType()} 
                                guessStatus={guessStatus} 
                                flip={flip} 
                                usedIds={usedIds} 
                                triggerHint={triggerHint}
                            />
                        </div>
                    }
                    {gameStatus === "game over" &&
                        <div style={{ width: '100%', height: 8, backgroundColor: 'red', marginBottom: 10 }} />
                    }
                    {gameStatus === "in progress" &&
                        <ConnectorBlock isMobile={isMobile} color={'black'} active />
                    }
                    {createBlocksMobile(direction !== 'fwd' ? reverseArr(blocksFwd) : reverseArr(blocksBck), direction !== 'fwd' ? 'fwd' : 'bck')}
                    <SnakeBlock showGoBack={() => setShowGoBack(-1)} info={direction !== 'fwd' ? head : tail} />
            </div>
        </div>
    )
}




export default MobileGameContainer
